export default function Footer() {
  return (
    <footer className="footer">
      <span>Gospel Piano Coaching</span>
      <span>{new Date().getFullYear()}</span>
    </footer>
  );
}
